import { getChangePinUrl } from 'config/api';

import { PIN_TYPES } from 'store/user/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

async function changePin(pin: string, newPin: string) {
    return NagraInstance.put(
        getChangePinUrl(),
        {
            type: PIN_TYPES.AccessPin,
            value: pin,
            newValue: newPin,
        },
        { headers: { 'nv-tenant-id': 'nagra' } },
    );
}

export default changePin;
